import { render, staticRenderFns } from "./ResultsPage.vue?vue&type=template&id=27d7b846&lang=pug"
import script from "./ResultsPage.vue?vue&type=script&lang=js"
export * from "./ResultsPage.vue?vue&type=script&lang=js"
import style0 from "./ResultsPage.vue?vue&type=style&index=0&id=27d7b846&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports